var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
import { typeOf } from "../../type/typeOf";
/**
 * Immutably adds the item to the array if it's not already included; removes it if it's already included
 *
 * @aka toggleIn
 * @category Array
 * @template {T} - The type of the array
 * @template {R} - The return type of the optional reducer
 * @param {T[]} array - The original array
 * @param {T} item - The item to toggle
 * @param {(item: T) => R} [reducer] - Optional function to take an array item and reduce it to a value that will be used as the basis for the toggle comparison
 * @returns {T[]}
 * @example
 * const array = [1, 2, 3];
 *
 * toggle(array, 4)   //=> [1, 2, 3, 4]
 * toggle(array, 2)   //=> [1, 3]
 * @example
 * const array = [{ id: 1, value: 'a' }, { id: 2, value: 'b' }];
 * const reducer = x => x.id;
 *
 * toggle(array, { id: 3, value: 'c' }, reducer);
 * //=> [{ id: 1, value: 'a' }, { id: 2, value: 'b' }, { id: 3, value: 'c' }]
 *
 * toggle(array, { id: 1, value: 'a' }, reducer);
 * //=> [{ id: 2, value: 'b' }]
 * @docgen_example
 * const array = [{ id: 1, value: 'a' }, { id: 2, value: 'b' }];
 * const reducer = x => x.id;
 *
 * toggle(array, { id: 3, value: 'c' }, reducer);
 */
export var toggle = function (array, item, reducer) {
    if (isNotNilOrEmpty(reducer)) {
        var reducedItem_1 = reducer(item);
        return typeOf(array) === 'array' && isNotNilOrEmpty(array) && array.find(function (x) { return reducer(x) === reducedItem_1; })
            ? array.filter(function (x) { return reducer(x) !== reducedItem_1; })
            : __spreadArray(__spreadArray([], (array || []), true), [item], false);
    }
    return typeOf(array) === 'array' && isNotNilOrEmpty(array) && array.indexOf(item) >= 0
        ? array.filter(function (x) { return x !== item; })
        : __spreadArray(__spreadArray([], (array || []), true), [item], false);
};
